<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="countries.icon" class="mr-1"></i>
                        <span>{{ countries.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="code" :debounce="countries.debounce"
                                            placeholder="Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!code"
                                                @click="code = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="countries.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>


                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="countries" :icon="countries.icon"
                        :busy="countries.busy" :toolbarlibrary="countries.toolbarlibrary" :tools="countries.tools"
                        :badges="countries.badges" :fields="countries.fields" :items="countries.items"
                        :limit="countries.limit" :downloaded="countries.downloaded" :showpages="true"
                        :offset="countries.offset" :page="countries.page" @load="countries_load"
                        @click="countries_click" @changed="countries_click('save', $event)" @select="countries_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="countries.selected" :config="cconfig"
                    @discard="countries_click('discard')" @go="countries_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>
            </b-card-footer>

        </b-card>

    </div>
</template>


<script>
import gql from "graphql-tag";

import CountryEdit from "./Components/Setup_CountryEdit";

export default {
    name: "Countries",
    components: { CountryEdit },
    watch: {

        async name() {
            await this.countries_load(0);
        },
        async code() {
            await this.countries_load(0);
        },
    },
    data() {
        return {
            name: null,
            code: null,
            countries: {
                title: "Countries",
                icon: "fa fa-list",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "name",
                        label: "Name",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "continent",
                        label: "Continent",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.countries_load();
    },

    methods: {
        accessdenied() {
            this.countries.denied = [];
            if (!this.user.permissions.includes("setup_countries.admin")) {
                this.countries.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_countries.admin")) {
                this.countries.denied.push("add");
                this.countries.denied.push("save");
            }

        },

        async countries_load(offset, limit, page) {

            let state = this.countries;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                name: this.name,
                code: this.code,

            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_countries(
                $limit: Int
                $offset: Int
                $name: String            
                $code: String  
                     
              ) {
                setup_countries(
                  limit: $limit
                  offset: $offset
                  name: $name 
                  code: $code                 
                ) {
                  id
                  code                 
                  name
                  continent           
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_countries
                } else {
                    state.items = response.data.setup_countries;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async countries_click(a, ss) {

            let state = this.countries;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.countries_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.countries_load();
                    break;

                case "go":
                    this.component = null;
                    await this.countries_load();
                    break;
                case "add":
                case "edit":
                    this.component = "CountryEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async countries_select(ss, tools) {

            let state = this.countries;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {
            // let requirement = { ...this.requirement_bookerinitial };


            // let requirements = "";
            // for (var prop in requirement) {
            //   if (this.item[prop] == null) {
            //     requirements += requirement[prop] + ", ";
            //     // break;
            //   }
            // }
            // if (requirements.length > 0) {
            //   this.message =
            //     "<span class='text-danger'>" +
            //     requirements.slice(0, -1) +
            //     " required field(s). </span>";
            //   return;
            // }
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_countries_save(
                $rows: [setup_countries_input]             
              ) {
                setup_countries_save(rows: $rows) {
                    id
                    code
                    name
                    continent         
                      
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_countries_delete(
                $rows: [setup_countries_input]
              ) {
                setup_countries_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.countries_load(0);
        },
    },
};
</script>

<style></style>